import { ItemSubtitle, ItemTitle } from '@sleepstation/components'
import { HLayout, VLayout } from '@sleepstation/components-layouts'
import { LAYOUT_ALIGN, SIZE } from '@sleepstation/const'
import {
  marginLeft,
  propToHeight,
  propToTop,
  propToWidth,
} from '@sleepstation/style-api-helpers'
import { replaceTokens } from '@sleepstation/utils'
import PropTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components'

// -----------------------------------------------------------------------------
// Const
// -----------------------------------------------------------------------------

const WIDTHS = {
  [SIZE.DEFAULT]: [2.25, 2.75],
  [SIZE.LARGE]: [3.6],
}

const HEIGHTS = {
  [SIZE.DEFAULT]: [2.5, 3.2],
  [SIZE.LARGE]: [4],
}

const TOPS = {
  [SIZE.DEFAULT]: [-0.2, -0.3, -0.1, -0.15],
  [SIZE.LARGE]: [-0.2, -0.3, -0.1, -0.15],
}

const IMAGE_ALT_TEMPLATE = `Avatar for #{title}`

// -----------------------------------------------------------------------------
// Utils
// -----------------------------------------------------------------------------

const getImageAlt = replaceTokens(IMAGE_ALT_TEMPLATE)

// -----------------------------------------------------------------------------
// Sub-components
// -----------------------------------------------------------------------------

const Layout = styled(HLayout).attrs({
  as: `header`,
  spacing: 0.5,
  align: LAYOUT_ALIGN.CENTER,
})`
  ${marginLeft(-0.5)}

  > *:first-child {
    flex-shrink: 0;
  }

  > *:last-child {
    width: auto;
    height: auto;
    flex-basis: auto;
    flex-shrink: 1;
  }
`

const IconWrapper = styled.div`
  position: relative;
  ${propToWidth(`size`, WIDTHS)}
  ${propToHeight(`size`, HEIGHTS)}
  ${propToTop(`size`, TOPS)}

  > img {
    width: 100%;
    height: 100%;
  }
`

const Text = styled(VLayout).attrs(({ size }) => {
  const spacing = size === SIZE.LARGE ? 0.5 : 0

  return {
    spacing,
  }
})``

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const AvatarHeader = ({ title, subtitle, image, size }) => {
  const alt = getImageAlt({ title })
  return (
    <Layout>
      <IconWrapper size={size}>
        <img alt={alt} src={image.url} />
      </IconWrapper>
      <Text size={size}>
        <ItemTitle>{title}</ItemTitle>
        {subtitle && <ItemSubtitle>{subtitle}</ItemSubtitle>}
      </Text>
    </Layout>
  )
}

AvatarHeader.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  image: PropTypes.object.isRequired,
  size: PropTypes.string,
}

AvatarHeader.defaultProps = {
  size: SIZE.DEFAULT,
  subtitle: null,
}

export default AvatarHeader
